/* Maison Matcha — landing B2B « Les Stories » : défilement, progression, compteur, calcul, navigation.
   Dépend de assets/mm-b2b-core.js (window.MMB2B). Le tiroir est géré par assets/mm-b2b-form.js. */
(function () {
  'use strict';
  const C = window.MMB2B;
  if (!C) return;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function readConfig(root) {
    try { return JSON.parse(root.getAttribute('data-mmb-config') || '{}'); } catch (e) { return {}; }
  }

  function countUp(el) {
    const target = parseInt(el.getAttribute('data-mmb-count'), 10) || 0;
    if (reduceMotion) { el.textContent = target; return; }
    const start = performance.now();
    const duration = 1400;
    const step = (now) => {
      const p = Math.min(1, (now - start) / duration);
      el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }

  function initStories(root) {
    const cfg = C.normalizeConfig(readConfig(root));
    const stories = Array.from(root.querySelectorAll('.mmb-story'));
    if (!stories.length) return;
    const segs = Array.from(root.querySelectorAll('.mmb-prog i'));
    const floatBtn = root.querySelector('.mmb-float');
    const floatSub = root.querySelector('[data-mmb-float-sub]');
    const floatSubDefault = floatSub ? floatSub.textContent : '';
    const calc = root.querySelector('[data-mmb-calc]');
    let active = -1;

    const isOpen = () => root.classList.contains('is-open');

    function updateFloat() {
      if (!floatBtn) return;
      floatBtn.classList.toggle('is-hidden', active === stories.length - 1 || isOpen());
      if (floatSub) {
        const onCalc = active >= 0 && stories[active].dataset.type === 'calculator' && calc;
        floatSub.textContent = onCalc ? 'Pour ' + calc.value + ' matcha latte par jour' : floatSubDefault;
      }
    }

    function setActive(i) {
      if (i === active || i < 0) return;
      active = i;
      stories.forEach((s, k) => s.classList.toggle('is-active', k === i));
      segs.forEach((g, k) => g.classList.toggle('is-done', k <= i));
      root.dataset.status = stories[i].dataset.theme === 'dark' ? 'dark' : 'light';
      root.dataset.active = String(i);
      root.dataset.activeType = stories[i].dataset.type || '';
      const counter = stories[i].querySelector('[data-mmb-count]');
      if (counter) countUp(counter);
      updateFloat();
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.55) setActive(stories.indexOf(entry.target));
      });
    }, { threshold: [0.55] });
    stories.forEach((s) => observer.observe(s));

    function go(delta) {
      const target = Math.max(0, Math.min(stories.length - 1, Math.max(active, 0) + delta));
      stories[target].scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    }

    root.addEventListener('click', (e) => {
      const nav = e.target.closest('[data-mmb-nav]');
      if (nav) go(parseInt(nav.getAttribute('data-mmb-nav'), 10) || 0);
    });

    document.addEventListener('keydown', (e) => {
      if (isOpen() || e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey) return;
      if (e.target.closest && e.target.closest('input, textarea, select, [contenteditable]')) return;
      if (e.key === 'ArrowDown' || e.key === 'PageDown') { e.preventDefault(); go(1); }
      else if (e.key === 'ArrowUp' || e.key === 'PageUp') { e.preventDefault(); go(-1); }
    });

    function updateCalc() {
      if (!calc) return;
      const t = C.tier(parseInt(calc.value, 10), cfg);
      const out = (name, value) => root.querySelectorAll('[data-mmb-out="' + name + '"]').forEach((el) => { el.textContent = value; });
      out('n', t.drinksPerDay);
      out('price', C.formatEur(cfg.lattePrice));
      out('cpb', C.formatEur(t.costPerDrink));
      out('volume', C.formatVolume(t.gramsPerMonth));
      out('format', t.format);
      out('share', C.formatShare(t.share));
      calc.style.setProperty('--p', ((Number(calc.value) - Number(calc.min)) / (Number(calc.max) - Number(calc.min)) * 100) + '%');
      calc.setAttribute('aria-valuetext', t.drinksPerDay + ' matcha latte par jour, soit ' + C.formatEur(t.costPerDrink) + ' de matcha par boisson');
      updateFloat();
    }
    if (calc) { calc.addEventListener('input', updateCalc); updateCalc(); }

    root.addEventListener('mmb:drawer', updateFloat);
    root.classList.add('is-ready');
    setActive(0);
  }

  document.querySelectorAll('[data-mmb]').forEach(initStories);
})();
